module.exports = __webpack_public_path__ + "img/csomagjaink__also_bg_1360.a2ea0914.jpg";